import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SlideDown } from "react-slidedown";
import clsx from "clsx";
import "react-slidedown/lib/slidedown.css";
import { usePadding } from "@/components/utils/Padding";
import "./styles.scss";

/* #META
 {
  "NAME": "FAQ",
  "CLASSNAME": "faq-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const FAQ = ({ data }) => {
  const faqModule = data?.faq;
  if (!faqModule) return null;

  const { questions, heading_color, padding_component, expand_question } = faqModule;
  const [openQuestions, setOpenQuestions] = useState({});

  // Open the first question if expand_question is true
  useEffect(() => {
    if (expand_question && questions.length > 0) {
      setOpenQuestions({ 0: true });
    }
  }, [expand_question, questions.length]);

  const toggleQuestion = (index) => {
    setOpenQuestions((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const halfLength = Math.ceil(questions?.length / 2);
  const leftQuestions = questions?.slice(0, halfLength) || [];
  const rightQuestions = questions?.slice(halfLength) || [];
  const paddingStyle = usePadding(padding_component);

  return (
    <div className="faq-component" style={paddingStyle}>
      <div className="container-revamp">
        <div className="faq-questions">
          <div className="faq-column">
            {leftQuestions.map((question, index) => {
              const isOpen = !!openQuestions[index];

              return (
                <div key={index} className={clsx("faq-question", isOpen && "is-open")}>
                  <div className="faq-question-header">
                    <h4 className={`faq-question-title faq-question-title--${heading_color}`}>
                      {question?.question_heading}
                    </h4>
                    <button
                      onClick={() => toggleQuestion(index)}
                      aria-expanded={isOpen}
                      className="faq-toggle-button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        style={{
                          transition: "transform 0.3s",
                          transform: openQuestions[index] ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                      >
                        <path
                          d="M6.3335 9.5L12.3335 15.5L18.3335 9.5"
                          stroke="#FDE5AC"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <SlideDown>
                    {openQuestions[index] && (
                      <div
                        className="faq-question-content"
                        dangerouslySetInnerHTML={{
                          __html: question?.question_content,
                        }}
                      />
                    )}
                  </SlideDown>
                </div>
              );
            })}
          </div>
          <div className="faq-column">
            {rightQuestions.map((question, index) => {
              // Adjust the index for the right column to be unique
              const adjustedIndex = index + halfLength;
              const isOpen = !!openQuestions[adjustedIndex];
              return (
                <div key={adjustedIndex} className={clsx("faq-question", isOpen && "is-open")}>
                  <div className="faq-question-header">
                    <h4 className={`faq-question-title faq-question-title--${heading_color}`}>
                      {question?.question_heading}
                    </h4>
                    <button
                      onClick={() => toggleQuestion(adjustedIndex)}
                      aria-expanded={isOpen}
                      className="faq-toggle-button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        style={{
                          transition: "transform 0.3s",
                          transform: openQuestions[adjustedIndex]
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <path
                          d="M6.3335 9.5L12.3335 15.5L18.3335 9.5"
                          stroke="#FDE5AC"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <SlideDown>
                    {openQuestions[adjustedIndex] && (
                      <div
                        className="faq-question-content"
                        dangerouslySetInnerHTML={{
                          __html: question?.question_content,
                        }}
                      />
                    )}
                  </SlideDown>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

FAQ.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    faq: PropTypes.shape({
      padding_component: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
      expand_question: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
      heading_color: PropTypes.string,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          question_heading: PropTypes.string,
          question_content: PropTypes.string,
        })
      ),
    }),
  }),
};

export default FAQ;
